import { SprintCalendarSection } from '../dashboard/sprints/sprint-calendar'

/**
 * The body of the Sprint management section: the client's Sprint calendar and
 * its skip controls (LG-412). The settings shell supplies the page frame, the
 * section heading, the nav and the document title.
 */
export function SprintManagement() {
  return <SprintCalendarSection />
}
